// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class QpsignatureAttestation {
    static getAttributeTypeMap() {
        return QpsignatureAttestation.attributeTypeMap;
    }
}
QpsignatureAttestation.discriminator = undefined;
QpsignatureAttestation.additionalProperties = false;
QpsignatureAttestation.attributeTypeMap = [
    {
        "name": "attestationAttributeCode",
        "baseName": "attestationAttributeCode",
        "type": "string"
    },
];
//# sourceMappingURL=qpsignatureAttestation.js.map